<template>
  <div class="global-modals-wrapper">
    <new-feature-modal />
    <upgrade-modal />
    <payment-toast />
    <!-- <verify-email-modal /> -->

    <component
      :is="modal.component"
      v-for="modal in modals"
      :ref="modal.ref"
      :key="modal.id"
      v-bind="modal.props"
      v-on="modal.on"
    >
      <template
        v-for="(slot, key) in modal.scopedSlots"
        #[`${key}`]="slotProps"
      >
        <component :is="slot(slotProps)" :key="key" />
      </template>
    </component>
  </div>
</template>

<script>
import NewFeatureModal from "./new_feature_modal.vue";
import UpgradeModal from "./upgrade_modal.vue";
import PaymentToast from "./payment_toast.vue";
// import VerifyEmailModal from "./verify_email_modal.vue";

export default {
  components: {
    NewFeatureModal,
    UpgradeModal,
    PaymentToast,
    // VerifyEmailModal,
  },

  computed: {
    modals() {
      return this.$egModal._data.modals;
    },
  },
};
</script>
